import type { LucideIcon } from 'lucide-react';
import {
  Banknote,
  DollarSign,
  Euro,
  IndianRupee,
  JapaneseYen,
  PhilippinePeso,
  PoundSterling,
  RussianRuble,
  SwissFranc,
  TurkishLira,
} from 'lucide-react';

const currencyIconMap: Record<string, LucideIcon> = {
  GBP: PoundSterling,
  EUR: Euro,
  USD: DollarSign,
  CAD: DollarSign,
  AUD: DollarSign,
  NZD: DollarSign,
  HKD: DollarSign,
  SGD: DollarSign,
  JPY: JapaneseYen,
  CNY: JapaneseYen,
  INR: IndianRupee,
  CHF: SwissFranc,
  RUB: RussianRuble,
  TRY: TurkishLira,
  PHP: PhilippinePeso,
};

/**
 * Returns the Lucide icon component matching a currency code.
 * Falls back to `Banknote` for unrecognised codes.
 *
 * Use directly as a component reference where `LucideIcon` is expected:
 *   icon={getCurrencyIcon(currencyCode)}
 */
export function getCurrencyIcon(currencyCode?: string | null): LucideIcon {
  if (!currencyCode) return Banknote;
  return currencyIconMap[currencyCode.toUpperCase()] ?? Banknote;
}

/**
 * Renders the currency-appropriate icon inline.
 *
 * <CurrencyIcon currencyCode="EUR" className="h-3 w-3" />
 */
export function CurrencyIcon({
  currencyCode,
  className,
}: Readonly<{ currencyCode?: string | null; className?: string }>) {
  const Icon = getCurrencyIcon(currencyCode);
  return <Icon className={className} />;
}
